









import { defineComponent } from "@vue/composition-api";
import { getMediaDuration } from "@/lib/time";

const DEFAULT_DURATION_VALUE = "0:00";

export default defineComponent({
  name: "BaseDuration",
  props: {
    value: { type: [String, Number], required: true },
    transparent: { type: Boolean, default: false },
    backgroundColor: { type: String },
  },
  computed: {
    duration(): string {
      const value = Number(this.value);
      if (isNaN(value) || this.value <= 0) return DEFAULT_DURATION_VALUE;
      return getMediaDuration(Number(this.value));
    },
  },
});
